import { instanceIdAtom, maxTime, residueTimeAtom, timerRunningAtom } from "lib/globalState";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import SimpleDialog from "components/SimpleDialog";
import { Typography } from "@mui/material";
import PepperChat from "assets/images/pepper_chat.svg";
import { fireAuth, firestore, functions } from "lib/firebase";
import { useHistory } from "react-router";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { currentAppAtom } from "../lib/globalState";
import { useObjectVal } from "react-firebase-hooks/database";
import { fireRDB } from "../lib/firebase";

const Timer = () => {
	const [timerRunning, setTimerRunning] = useRecoilState(timerRunningAtom);
	const [residueTime, setResidueTime] = useRecoilState(residueTimeAtom);
	const [openTimer, setOpenTimer] = useState(false);
	const appId = useRecoilValue(currentAppAtom);
	const instanceId = useRecoilValue(instanceIdAtom);
	const [queueCount] = useDocumentData(firestore.doc(`/apps/${appId}/waiting_queue/${instanceId}`));
	const [timerScadutoCount, setTimerScadutoCount] = useState(0);
	const history = useHistory();
	const [snapshot, loading, error] = useObjectVal(fireRDB.ref(`/robots/${instanceId}/online`));

	const refreshToken = () => {
		try {
			const refreshToken = functions.httpsCallable("areax_refreshToken");

			refreshToken({instanceId: instanceId})
			.then((result) => {
				const {success, error} = result.data;
				if (success) {
					console.log("token refresh ok");
				} else {
					console.log(error);
				}
			});
		} catch (e) {
			console.log(e);
		}
	};

	const expireToken = () => {
		try {
			const expireTokenF = functions.httpsCallable("areax_expireToken");
			expireTokenF({instanceId})
			.then((result) => {
				const {success, error} = result.data;
				if (success) {
					console.log("token expire ok");
					fireAuth.signOut();
				} else {
					console.log(error);
				}
			});
		} catch (e) {
			console.log(e);
		}
	};

	useEffect(() => {
		if (timerRunning) {
			const interval = setInterval(() => {
				setResidueTime((curr) => curr - 1000);
			}, 1000);
			return () => clearInterval(interval);
		}
	}, [timerRunning]);

	useEffect(() => {
		if (residueTime <= 0) {
			setTimerRunning(false);
			setTimerScadutoCount(prev => prev + 1);
			console.log("timer finito", "count", timerScadutoCount);
			if (queueCount?.count && queueCount.count > 0) {
				expireToken();
			} else if (timerScadutoCount >= 3) {
				expireToken();
			} else {
				setOpenTimer(true);
			}
		} else {
			console.log("timer running", residueTime / 1000);
		}
	}, [residueTime]);

	useEffect(() => {
		if (snapshot === false) {
			console.log("robot offline");
			if (fireAuth.currentUser) {
				console.log("expiring user token");
				expireToken();
			}
		}
	}, [snapshot]);

	const onContinue = async () => {
		setResidueTime(maxTime);
		refreshToken();
		setTimerRunning(true);
	};

	const onCancel = () => {
		console.log("cancel");
		history.push("/fine");
	};

	return <SimpleDialog
		open={openTimer}
		title={`Stai interagendo con Pepper da ${(((maxTime) / 1000 / 60).toFixed(0) * (timerScadutoCount === 0 ? 1 : timerScadutoCount)).toString()} minuti `}
		onConfirm={onContinue}
		onCancel={onCancel}
		headerImage={PepperChat}
		cancelLabel="Esci"
		onClose={() => setOpenTimer(false)}
	>
		<Typography>Scegli “Continua” se vuoi proseguire
			nell’esperienza, altrimenti scegli “Esci”
			per salutare Pepper.</Typography>
	</SimpleDialog>;
};

export default Timer;